import { ServiceInfoDc } from "@evergis/api";

const arcServiceType = "ProxyService";

export const useArcTypeService = (layerInfo: Partial<ServiceInfoDc>) =>
  layerInfo?.type && layerInfo.type === arcServiceType;
